import type { InspectCheck, InspectReport } from "../net/api";

const LABELS: Record<string, string> = {
  triangles: "面數", textures: "貼圖數", texture_size: "貼圖最大邊", nodes: "節點數",
  joints: "骨頭數（每個 skin）", grounded: "落地", extensions: "擴充",
};

export interface HealthRow { label: string; ok: boolean; text: string }

const n = (v: number | string[]) => (typeof v === "number" ? v.toLocaleString("en-US") : v.join("、"));

function wording(c: InspectCheck): string {
  switch (c.rule) {
    case "grounded": return `最低點 ${(c.value as number).toFixed(3)} m（容差 ±${c.limit} m）`;
    case "extensions": {
      const bad = c.value as string[];
      return bad.length ? `站上不解碼：${bad.join("、")}` : "沒有站上不解碼的擴充";
    }
    case "texture_size": return `${n(c.value)} px／上限 ${n(c.limit)} px`;
    default: return `${n(c.value)}／上限 ${n(c.limit)}`;
  }
}

/** One row per check, in the server's order (spec 2o §2.4). */
export function healthRows(r: InspectReport): HealthRow[] {
  return r.checks.map((c) => ({ label: LABELS[c.rule] ?? c.rule, ok: c.ok, text: wording(c) }));
}

export function factsLine(r: InspectReport): string {
  const size = r.size.map((v) => v.toFixed(2)).join(" × ");
  return `${r.skins.length} 個 skin、${r.clips.length} 支 clip、${r.node_count} 個節點、${size} m`;
}
